import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const NewsPage = () => {
  // Sample news data
  const featuredNews = {
    title: 'CalBiome Launches Revolutionary Microbiota Reset Protocol',
    date: 'June 15, 2023',
    image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    summary: 'CalBiome announces the release of its groundbreaking Microbiota Reset Protocol, a comprehensive approach to gut health backed by years of research from the California Institute for Microbiome Research (CalMiR).',
    readTime: '5 min read'
  };
  const newsItems = [{
    id: 1,
    title: "New Study Confirms Efficacy of CalBiome's Biofilm Disruptors",
    date: 'May 22, 2023',
    image: 'https://images.unsplash.com/photo-1576086213369-97a306d36557?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    summary: "A recent peer-reviewed study validates the effectiveness of CalBiome's proprietary biofilm disruption technology in improving probiotic colonization.",
    readTime: '3 min read'
  }, {
    id: 2,
    title: 'CalBiome Partners with Global Health Initiative for Afya Program Expansion',
    date: 'April 10, 2023',
    image: 'https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    summary: 'CalBiome announces a strategic partnership to expand its Afya Program, bringing microbiome solutions to underserved communities worldwide.',
    readTime: '4 min read'
  }, {
    id: 3,
    title: 'Ukweli Certification Program Sets New Standard for Microbiome Products',
    date: 'March 5, 2023',
    image: 'https://images.unsplash.com/photo-1614935151651-0bea6508db6b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    summary: 'The Ukweli Certification Program, developed in collaboration with CalBiome, establishes rigorous new standards for microbiome product validation.',
    readTime: '3 min read'
  }, {
    id: 4,
    title: 'CalMiR Research Breakthrough: New Insights into Gut-Brain Connection',
    date: 'February 18, 2023',
    image: 'https://images.unsplash.com/photo-1559757175-7cb056fba93d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    summary: "Scientists at CalMiR have discovered new mechanisms linking gut microbiome health to cognitive function, with implications for CalBiome's future product development.",
    readTime: '6 min read'
  }, {
    id: 5,
    title: 'CalBiome to Present at International Microbiome Conference',
    date: 'January 30, 2023',
    image: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    summary: 'CalBiome researchers will present findings on next-generation probiotics at the upcoming International Microbiome Conference in Geneva.',
    readTime: '2 min read'
  }, {
    id: 6,
    title: "Annual Report: CalBiome's Impact on Microbiome Science and Global Health",
    date: 'December 15, 2022',
    image: 'https://images.unsplash.com/photo-1606761568499-6d2451b23c66?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    summary: 'CalBiome releases its annual report highlighting key achievements in research, product development, and global health initiatives over the past year.',
    readTime: '5 min read'
  }];
  return <div className="min-h-screen bg-white" data-id="element-430" data-mp="3ttmddbtldyhl">
      <Navbar data-id="element-431" data-mp="1mze4u2vdnil" />
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-teal-900 to-teal-800 text-white" data-id="element-432" data-mp="1lxrdschrcl1">
        <div className="absolute inset-0 overflow-hidden" data-id="element-433" data-mp="2iatgr7k3tbiq">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1588681664899-f142ff2dc9b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center opacity-20" data-id="element-434" data-mp="2mehoprcne94i"></div>
        </div>
        <div className="relative container mx-auto px-4 py-24 max-w-7xl" data-id="element-435" data-mp="2xtcv0jb90nwk">
          <div className="max-w-3xl" data-id="element-436" data-mp="2sv1iu1xhe1b6">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-437" data-mp="2sw2uo8mbmrty">
              CalBiome News
            </h1>
            <p className="text-xl mb-8 text-teal-100" data-id="element-438" data-mp="2nxsz3wwopp7t">
              Stay updated with the latest breakthroughs, product announcements,
              and initiatives from CalBiome
            </p>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4 py-16 max-w-7xl" data-id="element-439" data-mp="3bl17inpetee2">
        {/* Featured News */}
        <div className="mb-16" data-id="element-440" data-mp="37kqqmg02x3kf">
          <h2 className="text-2xl font-bold text-gray-800 mb-8" data-id="element-441" data-mp="37jo0496o5351">
            Featured Story
          </h2>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-442" data-mp="20870bak85c0c">
            <div className="md:flex" data-id="element-443" data-mp="1w3zb7c9utu1l">
              <div className="md:w-1/2" data-id="element-444" data-mp="1w75472lltg2l">
                <img src={featuredNews.image} alt={featuredNews.title} className="h-64 w-full object-cover md:h-full" data-id="element-445" data-mp="bnjdcz3jly4i" />
              </div>
              <div className="md:w-1/2 p-8" data-id="element-446" data-mp="kng1mzm0suz1">
                <div className="uppercase tracking-wide text-sm text-teal-600 font-semibold mb-1" data-id="element-447" data-mp="klldzdjd6or9">
                  {featuredNews.date}
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-448" data-mp="ucg10k4fpsdr">
                  {featuredNews.title}
                </h3>
                <p className="text-gray-700 mb-6" data-id="element-449" data-mp="zarbmx2k06x1">{featuredNews.summary}</p>
                <div className="flex items-center justify-between" data-id="element-450" data-mp="13fh40by073d7">
                  <span className="text-sm text-gray-500" data-id="element-451" data-mp="18dsdumoatdvf">
                    {featuredNews.readTime}
                  </span>
                  <Link to="/news/microbiota-reset-protocol" className="inline-flex items-center text-teal-600 hover:text-teal-800 transition-colors duration-300" data-id="element-452" data-mp="356u7qxo8j57o">
                    Read more <ArrowRight size={16} className="ml-1" data-id="element-453" data-mp="hc9frc60rli3" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Latest News */}
        <div data-id="element-454" data-mp="q8qq4d6k7fcs">
          <h2 className="text-2xl font-bold text-gray-800 mb-8" data-id="element-455" data-mp="lbqivyxz46k3">Latest News</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-456" data-mp="lduyvf95cw0q">
            {newsItems.map(item => <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col h-full" data-id="element-457" data-mp="v9y10l400uno">
                <img src={item.image} alt={item.title} className="h-48 w-full object-cover" data-id="element-458" data-mp="190jj47lmp0ki" />
                <div className="p-6 flex flex-col flex-grow" data-id="element-459" data-mp="1iyplsrf9eaqf">
                  <div className="uppercase tracking-wide text-xs text-teal-600 font-semibold mb-1" data-id="element-460" data-mp="1ix66b31fg3pp">
                    {item.date}
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-461" data-mp="1xniu9pm9od3y">
                    {item.title}
                  </h3>
                  <p className="text-gray-700 mb-4 flex-grow" data-id="element-462" data-mp="22j7w5zlre63f">{item.summary}</p>
                  <div className="flex items-center justify-between mt-auto" data-id="element-463" data-mp="1nni69qdgd8tf">
                    <span className="text-sm text-gray-500" data-id="element-464" data-mp="1sm3bk47kaioq">
                      {item.readTime}
                    </span>
                    <Link to="#" className="inline-flex items-center text-teal-600 hover:text-teal-800 transition-colors duration-300" data-id="element-465" data-mp="1euf08354zy8t">
                      Read more <ArrowRight size={16} className="ml-1" data-id="element-466" data-mp="14vfq0g4q3ujp" />
                    </Link>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        {/* Newsletter Signup */}
        <div className="mt-16 bg-teal-50 rounded-lg p-8 border border-teal-100" data-id="element-467" data-mp="zy7euzhzsqry">
          <div className="md:flex items-center justify-between" data-id="element-468" data-mp="100a6tp2pgtzb">
            <div className="md:w-2/3 mb-6 md:mb-0" data-id="element-469" data-mp="1gdgc1wq2byut">
              <h3 className="text-2xl font-bold text-teal-800 mb-2" data-id="element-470" data-mp="1bec1p2rejv2w">
                Subscribe to Our Newsletter
              </h3>
              <p className="text-gray-700" data-id="element-471" data-mp="16ehaey3pt3hb">
                Get the latest updates on microbiome research, product launches,
                and CalBiome events delivered to your inbox.
              </p>
            </div>
            <div className="md:w-1/3" data-id="element-472" data-mp="xgf4q591dmnp">
              <form className="flex flex-col sm:flex-row" data-id="element-473" data-mp="sonlkfs7mj7l">
                <input type="email" placeholder="Your email address" className="px-4 py-2 rounded-l-lg w-full focus:outline-none focus:ring-2 focus:ring-teal-600 border border-gray-300" data-id="element-474" data-mp="sn2rssdpz4as" />
                <button type="submit" className="bg-teal-600 text-white px-4 py-2 rounded-r-lg font-medium hover:bg-teal-700 transition-colors duration-300 mt-2 sm:mt-0" data-id="element-475" data-mp="drd1wj5ey70s">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer data-id="element-476" data-mp="2pgb69bgz0xxq" />
    </div>;
};
export default NewsPage;